<template>
  <div class="version">
    <div class="">FRONT: v{{ frontVersion }}</div>
    <div class="">BACK: v{{ backVersion }}</div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'Version',

  data() {
    return {
      frontVersion: config.BUILD_VERSION,
      backVersion: null,
      loading: false,
      error: null,
    };
  },

  mounted() {
    this.$store
      .dispatch('backVersion')
      .then(result => {
        this.loading = false;
        this.backVersion = result;
      })
      .catch(e => {
        this.loading = false;
        switch (e.code) {
          default:
            this.error = e.error;
            break;
        }
      });
  },
};
</script>
